module.exports = __webpack_public_path__ + "images/emoji/earth_asia.6de30653aeec10c3659e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/earth_asia.png
// module id = UAeg
// module chunks = 1